<div class="consent-container" *ngIf="status === 'READY' || status === 'SUBMITTING'">
  <h2 class="consent-title">{{ 'TEAMS_CONSENT.TITLE' | translate }}</h2>

  <p class="consent-description">{{ 'TEAMS_CONSENT.DESCRIPTION' | translate }}</p>

  <p class="consent-prompt">{{ 'TEAMS_CONSENT.PROMPT' | translate }} <span class="required">*</span></p>

  <label class="radio-option" (click)="selectedOption = true">
    <input type="radio" name="consent" [checked]="selectedOption === true" />
    {{ 'TEAMS_CONSENT.OPTION_CONSENT' | translate }}
  </label>

  <label class="radio-option" (click)="selectedOption = false">
    <input type="radio" name="consent" [checked]="selectedOption === false" />
    {{ 'TEAMS_CONSENT.OPTION_DECLINE' | translate }}
  </label>

  <div class="consent-actions">
    <button class="btn confirm" (click)="confirm()" [disabled]="selectedOption === null || status === 'SUBMITTING'">
      {{ 'TEAMS_CONSENT.CONFIRM' | translate }}
    </button>
  </div>
</div>

<div class="consent-container" *ngIf="status === 'LOADING'">
  <div class="loading-spinner"></div>
</div>

<div class="consent-container" *ngIf="status === 'ERROR'">
  <p class="error-text">{{ errorMessage }}</p>
</div>
